module.exports = __webpack_public_path__ + "img/fi-rr-unlock.e60f48a7.svg";